import * as React from "react";
import { styled } from "@mui/material";
import { GenderValue } from "shared";
import { PatientSummaryData } from "fe-common/graphql";
import clsx from "clsx";
import GenderIcon from "fe-web-components/genderIcon/GenderIcon";
import { ThemeSettings } from "@kahunmedical/common-configuration";
import { useSummaryTranslations } from "./translate/useSummaryTranslations";
//region [[ Styles ]]

const PatientCardAgeAndGenderView = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  "& .gender-icon-view": {
    margin: "0 8px",
  },
  "& .gender-text": {
    textTransform: "capitalize",
  },
});

const GenderText = styled("div")({
  // color: "#5A52C3",
  // fontSize: "17px",
  // fontWeight: 700,
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientCardAgeAndGenderProps {
  className?: string;
  summary: PatientSummaryData;
  themeSettings: ThemeSettings;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientCardAgeAndGender = ({
  themeSettings,
  summary,
  ...props
}: PatientCardAgeAndGenderProps) => {
  const { translate } = useSummaryTranslations(summary);

  return (
    <PatientCardAgeAndGenderView
      className={clsx("patient-card-age-and-gender", props.className)}
    >
      <GenderIcon
        gender={summary.gender as GenderValue}
        themeSettings={themeSettings}
      />
      <GenderText className={"gender-text"}>
        {translate("AGE_GENDER", { age: summary.age?.toString() })}
      </GenderText>
    </PatientCardAgeAndGenderView>
  );
};
